import { render, staticRenderFns } from "./FixedMatterInformationGeneralTab.vue?vue&type=template&id=535edf5c&"
import script from "./FixedMatterInformationGeneralTab.vue?vue&type=script&lang=ts&"
export * from "./FixedMatterInformationGeneralTab.vue?vue&type=script&lang=ts&"
import style0 from "./FixedMatterInformationGeneralTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports